(function () {
  "use strict";

  const MOBILE_QUERY = "(max-width: 749px)";
  const SELECTOR = "product-images.product__images--mobile-peek";

  class ProductMobilePeek {
    constructor(container) {
      this.container = container;
      this.slides = container.querySelector("[data-product-media-list]");
      this.mediaItems = container.querySelectorAll("[data-slide]");
      this.scrollTicking = false;
      this.onScroll = this.onScroll.bind(this);
      this.onMediaSelect = this.onMediaSelect.bind(this);
      this.onResize = this.onResize.bind(this);
    }

    isActive() {
      return (
        window.matchMedia(MOBILE_QUERY).matches && this.mediaItems.length > 1
      );
    }

    getClosestMediaId() {
      const scrollLeft = this.slides.scrollLeft;
      let closest = this.mediaItems[0];
      let closestDistance = Infinity;

      this.mediaItems.forEach((item) => {
        const distance = Math.abs(item.offsetLeft - scrollLeft);

        if (distance < closestDistance) {
          closestDistance = distance;
          closest = item;
        }
      });

      return closest.getAttribute("data-media-id");
    }

    onScroll() {
      if (!this.scrollTicking) {
        this.scrollTicking = true;

        requestAnimationFrame(() => {
          const id = this.getClosestMediaId();
          const current = this.container.getAttribute("data-active-media");

          if (id && id !== current) {
            this.container.setAttribute("data-active-media", id);
          }

          this.scrollTicking = false;
        });
      }
    }

    onMediaSelect(event) {
      const id = event.detail?.id;

      if (!id || !this.isActive()) return;

      const target = this.container.querySelector(`[data-media-id="${id}"]`);

      if (!target || !this.slides) return;

      this.slides.scrollTo({
        left: target.offsetLeft,
        behavior: "smooth",
      });
    }

    bind() {
      this.slides?.addEventListener("scroll", this.onScroll, { passive: true });
      this.container.addEventListener("theme:media:select", this.onMediaSelect);
      window.addEventListener("theme:resize:width", this.onResize);
    }

    unbind() {
      this.slides?.removeEventListener("scroll", this.onScroll);
      this.container.removeEventListener(
        "theme:media:select",
        this.onMediaSelect,
      );
      window.removeEventListener("theme:resize:width", this.onResize);
    }

    init() {
      this.unbind();

      if (!this.isActive()) return;

      this.bind();
    }

    onResize() {
      this.init();
    }

    destroy() {
      this.unbind();
    }
  }

  function initSliders(root = document) {
    root.querySelectorAll(SELECTOR).forEach((container) => {
      if (!container._productMobilePeek) {
        container._productMobilePeek = new ProductMobilePeek(container);
      }

      container._productMobilePeek.init();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initSliders());
  } else {
    initSliders();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initSliders(event.target);
  });
})();
